import { api } from '../../api/client';

export type LoginPairingUser = {
  id: string;
  nome: string;
  email: string;
  perfil: string;
  cargo?: string | null;
  escolaId?: string | null;
  fotoUrl?: string | null;
};

export type LoginPairingLogin = {
  access_token: string;
  refresh_token?: string;
  user: LoginPairingUser & Record<string, unknown>;
};

export type LoginPairingPayload = {
  user: LoginPairingUser;
  login?: LoginPairingLogin | null;
};

export type LoginPairingQrSession = {
  sessionId: string;
  expiraEm: string;
  maxExpiraEm?: string | null;
  intent: 'login_pairing';
  bondingPath: string;
};

export type LoginPairingStatus = {
  status: string;
  currentStep?: string | null;
  intent?: string;
  expiraEm?: string;
  maxExpiraEm?: string | null;
  user?: LoginPairingUser | null;
  login?: LoginPairingLogin | null;
};

export type LoginPairingClaim = {
  ok: true;
  status: string;
  user: LoginPairingUser;
  login?: LoginPairingLogin | null;
};

export async function createLoginPairingQr(fingerprint: string): Promise<LoginPairingQrSession> {
  const { data } = await api.post<LoginPairingQrSession>('/auth/login-pairing-qr', {
    fingerprint,
  });
  return data;
}

export async function getLoginPairingStatus(sessionId: string): Promise<LoginPairingStatus> {
  const { data } = await api.get<LoginPairingStatus>(
    `/auth/link-status/${encodeURIComponent(sessionId)}`,
  );
  return data;
}

export async function claimLoginPairingSession(sessionId: string): Promise<LoginPairingClaim> {
  const { data } = await api.post<LoginPairingClaim>(
    `/auth/session/${encodeURIComponent(sessionId)}/claim-login-pairing`,
  );
  return data;
}

export async function cancelLoginPairingSession(sessionId: string, desktopFingerprint: string): Promise<void> {
  await api.post(`/auth/session/${encodeURIComponent(sessionId)}/cancel-login-pairing`, {
    desktopFingerprint,
  });
}
